"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_transform_1 = require("prosemirror-transform");
var DropCursorView = /** @class */ (function () {
    function DropCursorView(editorView, config) {
        var _this = this;
        if (config === void 0) { config = {}; }
        this.config = { width: 1, color: '#000000' };
        this.editorView = editorView;
        this.class = 'syl-drop-cursor';
        this.cursorPos = null;
        this.element = null;
        this.timeout = null;
        Object.assign(this.config, config);
        this.handlers = [
            'dragover',
            'dragend',
            'drop',
            'dragleave'
        ].map(function (name) {
            var handler = function (e) { return _this[name](e); };
            editorView.dom.addEventListener(name, handler);
            return { name: name, handler: handler };
        });
    }
    DropCursorView.prototype.destroy = function () {
        var _this = this;
        this.handlers.forEach(function (_a) {
            var name = _a.name, handler = _a.handler;
            return _this.editorView.dom.removeEventListener(name, handler);
        });
    };
    DropCursorView.prototype.update = function (editorView, prevState) {
        if (this.cursorPos !== null && prevState.doc !== editorView.state.doc) {
            this.updateOverlay();
        }
    };
    DropCursorView.prototype.setCursor = function (pos) {
        if (pos === this.cursorPos)
            return;
        this.cursorPos = pos;
        if (pos === null) {
            this.element.parentNode.removeChild(this.element);
            this.element = null;
        }
        else {
            this.updateOverlay();
        }
    };
    DropCursorView.prototype.updateOverlay = function () {
        var $pos = this.editorView.state.doc.resolve(this.cursorPos);
        var rect;
        // 不是从textblock开始拖出来
        if (!$pos.parent.inlineContent) {
            var before = $pos.nodeBefore;
            var after = $pos.nodeAfter;
            if (before || after) {
                var beforeDOM = this.editorView.nodeDOM(this.cursorPos - (before ? before.nodeSize : 0));
                var beforeRect = beforeDOM.getBoundingClientRect();
                var top_1 = before ? beforeRect.bottom : beforeRect.top;
                if (before && after) {
                    var curDOM = this.editorView.nodeDOM(this.cursorPos);
                    if (curDOM) {
                        var curRect = curDOM.getBoundingClientRect();
                        top_1 = (top_1 + curRect.top) / 2;
                    }
                }
                rect = {
                    left: beforeRect.left,
                    right: beforeRect.right,
                    top: top_1 - this.config.width / 2,
                    bottom: top_1 + this.config.width / 2
                };
            }
        }
        if (!rect) {
            var coords = this.editorView.coordsAtPos(this.cursorPos);
            rect = {
                left: coords.left - this.config.width / 2,
                right: coords.left + this.config.width / 2,
                top: coords.top,
                bottom: coords.bottom
            };
        }
        var parent = this.editorView.dom.offsetParent;
        if (!this.element && parent) {
            this.element = parent.appendChild(document.createElement('div'));
            if (this.class)
                this.element.className = this.class;
            this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;background-color: " + this.config.color;
        }
        var parentRect = !parent ||
            (parent === document.body &&
                getComputedStyle(parent).position === 'static')
            ? { left: -pageXOffset, top: -pageYOffset }
            : parent.getBoundingClientRect();
        this.element.style.left = rect.left - parentRect.left + 'px';
        this.element.style.top = rect.top - parentRect.top + 'px';
        this.element.style.width = rect.right - rect.left + 'px';
        this.element.style.height = rect.bottom - rect.top + 'px';
    };
    DropCursorView.prototype.scheduleRemoval = function (timeout) {
        var _this = this;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () { return _this.setCursor(null); }, timeout);
    };
    DropCursorView.prototype.dragover = function (event) {
        if (!this.editorView.editable)
            return;
        var pos = this.editorView.posAtCoords({
            left: event.clientX,
            top: event.clientY
        });
        if (pos) {
            var target = pos.pos;
            if (this.editorView.dragging && this.editorView.dragging.slice) {
                target = prosemirror_transform_1.dropPoint(this.editorView.state.doc, target, this.editorView.dragging.slice);
                if (typeof target !== 'number')
                    target = pos.pos;
            }
            this.setCursor(target);
            this.scheduleRemoval(5000);
        }
    };
    DropCursorView.prototype.dragend = function () {
        this.scheduleRemoval(20);
    };
    DropCursorView.prototype.drop = function () {
        clearTimeout(this.timeout);
        this.setCursor(null);
    };
    DropCursorView.prototype.dragleave = function (event) {
        if (event.target === this.editorView.dom ||
            !this.editorView.dom.contains(event.relatedTarget)) {
            this.setCursor(null);
        }
    };
    return DropCursorView;
}());
exports.DropCursorView = DropCursorView;
//# sourceMappingURL=drop-cursor-view.js.map